export const REGLEMENT_FOURNISSEUR = {
    SET_REGLEMENTS: 'SET_REGLEMENTS',
    ADD_REGLEMENTS: 'ADD_REGLEMENTS',
    SET_FILTER_OPERATEUR: 'SET_FILTER_OPERATEUR',
    SET_FILTER_MONTANT: 'SET_FILTER_MONTANT',
    SET_FILTER_DATE_DEBUT: 'SET_FILTER_DATE_DEBUT',
    SET_FILTER_DATE_FIN: 'SET_FILTER_DATE_FIN',
    RESET_ITEMS: 'RESET_ITEMS',
    SET_REGLEMENTS_LOADING: 'SET_REGLEMENTS_LOADING',
    XLS_LOADING: 'XLS_LOADING',

    SET_SORT: 'SET_SORT',
    SET_SCROLL: 'SET_SCROLL',
    SET_NUMBER_OF_PAGES: 'SET_NUMBER_OF_PAGES',
    SET_PAGE: 'SET_PAGE',
    SET_NB_ELEMENTS: 'SET_NB_ELEMENTSs'
};
